import Title from "@components/Title";
import cn from "classnames";
import { FCX } from "@datassential/platform-ui-lib";
import ContentHeader from "@components/ContentHeader";
import { memo } from "react";

const VisualizeHeader: FCX = () => {
	return (
		<ContentHeader
			className="VisualizeHeader"
			testId="blockVisualizeHeader"
		>
			<Title
				className={cn(
					"appears-right",
				)}
				testId="textVisualizeHeaderTitle"
			>
				VISUALIZE
			</Title>
		</ContentHeader>
	)
}

export default memo(VisualizeHeader);